var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticStyle: { width: "fit-content" } }, [
        _c("div", { staticStyle: { display: "flex", height: "700px" } }, [
          _c(
            "div",
            { staticClass: "section form-column" },
            [
              _c(
                "el-form",
                {
                  staticStyle: { height: "100%" },
                  attrs: { "label-width": "112px" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "MBL" } },
                    [
                      _c("el-input", {
                        attrs: { no: "1", disabled: true },
                        model: {
                          value: _vm.mblNo,
                          callback: function($$v) {
                            _vm.mblNo = $$v
                          },
                          expression: "mblNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.TransportationClause") }
                    },
                    [
                      _c("el-input", {
                        attrs: { disabled: true, value: _vm.job.freightTerm }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.MasterBLFreightTerm") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "paymentTermMBL",
                          disabled: true,
                          "select-type":
                            _vm.selectTypeNames.basic_data_PaymentTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.job.paymentTermMBL
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TradeTerms2") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "incoTerm",
                          disabled: true,
                          "select-type":
                            _vm.selectTypeNames.basic_data_IncoTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.job.incoTerm
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.incoTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.job.containerLoadType === "FCL" ||
                  _vm.job.containerLoadType === "BB" ||
                  _vm.job.containerLoadType === "BCF" ||
                  _vm.job.containerLoadType === "BC"
                    ? _c("booking-sea-eq-data-grid", {
                        ref: "bookingSeaEqDataGrid",
                        attrs: {
                          no: "bookingSeaEqDataGrid",
                          value: _vm.seaEqList,
                          "is-edit": false,
                          "container-load-type": _vm.job.containerLoadType,
                          job: _vm.job
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "section form-column",
              staticStyle: { width: "350px" }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { height: "100%" },
                  attrs: {
                    "label-width": "112px",
                    "label-position": "right",
                    disabled: true
                  }
                },
                [
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.PortOfLoading")))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          ref: "loadingPortCode",
                          staticStyle: { flex: "1" },
                          attrs: {
                            no: "loadingPortCode",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            filterable: "",
                            "default-value": _vm.job.loadingPortCode,
                            "tag-name": "englishName"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "padding-left": "2px" },
                            attrs: { no: "transfering" },
                            model: {
                              value: _vm.job.transfering,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "transfering", $$v)
                              },
                              expression: "job.transfering"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Transit")))]
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.transfering,
                          expression: "job.transfering"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.TransitPort") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "transferPortCode",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.job.transferPortCode
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.PortOfDischarge")))]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "dischargingPortCode",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.job.dischargingPortCode
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.PlaceOfDelivery")))]
                      ),
                      _c("cargo-advance-select", {
                        staticClass: "port-of-delivery-selector",
                        attrs: {
                          no: "destinationPortCode",
                          "popper-class": "port-of-delivery-selector-popper",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.job.destinationPortCode
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_PlaceOfDeliveryRegion"))
                        )
                      ]),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "placeOfDeliveryRegion",
                          "select-type": _vm.selectTypeNames.basic_data_Region,
                          filterable: "",
                          "default-value": _vm.job.placeOfDeliveryRegion
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.placeOfDeliveryRegion = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.PlaceOfReceiptOnBl") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: true,
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.form.dispatchingPlaceCode || "",
                          "tag-name": "englishName"
                        }
                      }),
                      _c("el-input", {
                        attrs: { no: "52" },
                        model: {
                          value: _vm.form.dispatchingPlace,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "dispatchingPlace", $$v)
                          },
                          expression: "form.dispatchingPlace"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.PortOfLoadingOnBl") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: true,
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.form.loadingPortCode || "",
                          "tag-name": "englishName",
                          no: "loadingPortCode"
                        }
                      }),
                      _c("el-input", {
                        attrs: { no: "53" },
                        model: {
                          value: _vm.form.loadingPort,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "loadingPort", $$v)
                          },
                          expression: "form.loadingPort"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.PortOfDischargeOnBl") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: true,
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.form.dischargingPortCode || "",
                          "tag-name": "englishName",
                          no: "dischargingPortCode"
                        }
                      }),
                      _c("el-input", {
                        attrs: { no: "54" },
                        model: {
                          value: _vm.form.dischargingPort,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "dischargingPort", $$v)
                          },
                          expression: "form.dischargingPort"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.PlaceOfDeliveryOnBl") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: true,
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.form.destinationPortCode || "",
                          "tag-name": "englishName",
                          no: "destinationPortCode"
                        }
                      }),
                      _c("el-input", {
                        attrs: { no: "55" },
                        model: {
                          value: _vm.form.destinationPort,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "destinationPort", $$v)
                          },
                          expression: "form.destinationPort"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.DateOfDeparture2")))]
                    ),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          staticClass: "departure-date-picker",
                          staticStyle: { flex: "1", "margin-right": "5px" },
                          attrs: {
                            no: "etd",
                            value: _vm.job.etd,
                            "picker-options": {
                              disabledDate: _vm.disabledDate
                            },
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("el-form-item", [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.DateOfArrival2")))
                    ]),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { flex: "1", "margin-right": "5px" },
                          attrs: {
                            no: "eta",
                            "picker-options": {
                              disabledDate: _vm.disabledDate
                            },
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.job.eta,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "eta", $$v)
                            },
                            expression: "job.eta"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Vessel") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "5",
                          "select-type": _vm.selectTypeNames.static_data_Vessel,
                          cache: false,
                          filterable: "",
                          "default-value": _vm.job.vessel
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Voyage") } },
                    [
                      _c("cargo-advance-select", {
                        ref: "voyageFlight",
                        attrs: {
                          no: "6",
                          cache: false,
                          "default-value": _vm.job.voyageFlight,
                          filterable: "",
                          clearable: "",
                          "tag-name": "voyageNo",
                          "tag-value": "voyageNo",
                          "filter-tag-names": ["voyageNo"]
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.ShippingCompanyContractNo")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "10" },
                        model: {
                          value: _vm.job.scNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "scNo", $$v)
                          },
                          expression: "job.scNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "CNPT No." } },
                    [
                      _c("cargo-repeat-value-select", {
                        attrs: {
                          placeholder: "",
                          no: "cNptNo",
                          filterable: "",
                          "allow-create": true,
                          clearable: "",
                          options: _vm.cNptList,
                          "label-field": "no",
                          "value-field": "no",
                          "unique-field": "no",
                          "match-of-repeat-value": _vm.matchOfCNpt
                        },
                        on: {
                          change: _vm.cNptChangeHandler,
                          handleBlur: _vm.cNptBlurHandler
                        },
                        model: {
                          value: _vm.job.cNptNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cNptNo", $$v)
                          },
                          expression: "job.cNptNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_CarrierCode") } },
                    [
                      _c("el-input", {
                        attrs: { no: "carrierCode" },
                        model: {
                          value: _vm.job.carrierCode,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "carrierCode", $$v)
                          },
                          expression: "job.carrierCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId1",
                        attrs: {
                          no: "userDefinedRoleId1",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole1"
                          },
                          "default-value": _vm.job.userDefinedRoleId1 || "",
                          "merge-load": true
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId2",
                        attrs: {
                          no: "userDefinedRoleId2",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole2"
                          },
                          "default-value": _vm.job.userDefinedRoleId2 || "",
                          "merge-load": true
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "section form-column",
              staticStyle: { width: "350px" }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { height: "100%" },
                  attrs: {
                    "label-width": "112px",
                    "label-position": "right",
                    disabled: true
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.BlType") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "62" },
                          model: {
                            value: _vm.form.releaseType,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "releaseType", $$v)
                            },
                            expression: "form.releaseType"
                          }
                        },
                        _vm._l(_vm.blModeList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.name,
                              value: item.serialNumber
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.NumberOfPackagesOnBl") }
                    },
                    [
                      _c("auto-number-input", {
                        attrs: { no: "31", precision: 0, min: 0 },
                        model: {
                          value: _vm.form.quantity,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "quantity", $$v)
                          },
                          expression: "form.quantity"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Weight") } },
                    [
                      _c(
                        "div",
                        { staticClass: "form-item-input" },
                        [
                          _c("el-input-number", {
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "36",
                              precision: 3,
                              min: 0,
                              controls: false
                            },
                            model: {
                              value: _vm.form.weight,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "weight", $$v)
                              },
                              expression: "form.weight"
                            }
                          }),
                          _c("span", [_vm._v("KGS")])
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Cubage") } },
                    [
                      _c(
                        "div",
                        { staticClass: "form-item-input" },
                        [
                          _c("el-input-number", {
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "37",
                              precision: 3,
                              min: 0,
                              controls: false
                            },
                            model: {
                              value: _vm.form.cubage,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cubage", $$v)
                              },
                              expression: "form.cubage"
                            }
                          }),
                          _c("span", [_vm._v("CBM")])
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Package") } },
                    [
                      _c("cargo-packing-select", {
                        attrs: { no: "32", "default-value": _vm.form.packing }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: {
                        label: _vm.$t("SeaExport.EnglishDescriptionOfGoods")
                      }
                    },
                    [
                      _c(
                        "special-character-tip",
                        {
                          attrs: {
                            texts: _vm.specialCharCheck.cargoEnglishName
                          }
                        },
                        [
                          _c("cargo-rich-textarea", {
                            ref: "cargoTextarea1",
                            staticStyle: { height: "110px" },
                            attrs: {
                              no: "43",
                              "text-chars": _vm.englishNameMaxChars,
                              "warning-count": _vm.englishNameWarningCount,
                              "wrap-symbol": "r",
                              disabled: true,
                              "auto-uppercase": "",
                              "auto-half-word": ""
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                                  _vm.form.cargoEnglishName,
                                  function(val) {
                                    _vm.form.cargoEnglishName = val
                                  },
                                  false,
                                  null,
                                  true,
                                  {
                                    warningCount: _vm.englishNameWarningCount,
                                    maxChar: _vm.englishNameMaxChars,
                                    autoUppercase: true,
                                    autoHalfWord: true
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.cargoEnglishName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cargoEnglishName", $$v)
                              },
                              expression: "form.cargoEnglishName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.Marks") }
                    },
                    [
                      _c(
                        "special-character-tip",
                        { attrs: { texts: _vm.specialCharCheck.mark } },
                        [
                          _c("cargo-rich-textarea", {
                            ref: "cargoTextarea2",
                            staticStyle: { height: "110px" },
                            attrs: {
                              no: "48",
                              "text-chars": _vm.markMaxChars,
                              "warning-count": _vm.markWarningCount,
                              "wrap-symbol": "r",
                              disabled: true,
                              "auto-uppercase": "",
                              "auto-half-word": ""
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.Marks"),
                                  _vm.form.mark,
                                  function(val) {
                                    _vm.form.mark = val
                                  },
                                  false,
                                  null,
                                  true,
                                  {
                                    warningCount: _vm.markWarningCount,
                                    maxChar: _vm.markMaxChars,
                                    autoUppercase: true,
                                    autoHalfWord: true
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.mark,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mark", $$v)
                              },
                              expression: "form.mark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.HsCode") } },
                    [
                      _c("el-input", {
                        attrs: { no: "hsCode", type: "textarea", rows: 5 },
                        on: { input: function(val) {} },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.HsCode"),
                              _vm.hsCode,
                              function(val) {}
                            )
                          }
                        },
                        model: {
                          value: _vm.hsCode,
                          callback: function($$v) {
                            _vm.hsCode = $$v
                          },
                          expression: "hsCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.BlRemarks") } },
                    [
                      _c("el-input", {
                        attrs: { no: "remarks", type: "textarea", rows: 4 },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.Remarks"),
                              _vm.form.remarks,
                              function(val) {
                                _vm.form.remarks = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "remarks", $$v)
                          },
                          expression: "form.remarks"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.PortOfLoadingPOR") } },
                    [
                      _c("el-input", {
                        attrs: { no: "71" },
                        model: {
                          value: _vm.job.bargePOL,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "bargePOL", $$v)
                          },
                          expression: "job.bargePOL"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "section", staticStyle: { width: "100%" } }, [
          _c(
            "div",
            {
              staticClass: "form-row",
              staticStyle: {
                display: "flex",
                "flex-direction": "row",
                "margin-top": "8px"
              }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: { "label-width": "50px", "label-position": "left" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Shipper") } },
                    [
                      _c("cargo-input", {
                        staticStyle: { width: "115px", "margin-right": "5px" },
                        attrs: {
                          disabled: true,
                          no: "shipperCode",
                          placeholder: _vm.$t("SeaExport.ShipperId"),
                          "auto-uppercase": true
                        },
                        model: {
                          value: _vm.form.shipperCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "shipperCode", $$v)
                          },
                          expression: "form.shipperCode"
                        }
                      }),
                      _c("cargo-company-select", {
                        staticStyle: {
                          display: "inline-block",
                          width: "145px"
                        },
                        attrs: {
                          disabled: true,
                          no: "shipperId",
                          "method-params": { shipper: true, active: true },
                          "default-value": _vm.form.shipperId || ""
                        }
                      })
                    ],
                    1
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, attrs: { "label-width": "0" } },
                      [
                        _c(
                          "special-character-tip",
                          {
                            attrs: {
                              texts: _vm.specialCharCheck["shipperLine" + i]
                            }
                          },
                          [
                            _c("cargo-input", {
                              ref: "shipperLine" + i,
                              refInFor: true,
                              attrs: {
                                no: "shipperLine" + i,
                                disabled: true,
                                "auto-uppercase": true,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "shipperLine" + i,
                                    i + 1 > 7 ? null : "shipperLine" + (i + 1),
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.Shipper"),
                                    _vm.mergeShipperLine(),
                                    _vm.splitShipperLine,
                                    true,
                                    {
                                      autoHalfWord: true,
                                      autoUppercase: true,
                                      maxChar: _vm.maxChars,
                                      warningCount: _vm.warningCount
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.form["shipperLine" + i],
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperLine" + i, $$v)
                                },
                                expression: "form['shipperLine'+i]"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "margin-right": "20px" },
                  attrs: { "label-width": "65px", "label-position": "left" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Consignee") } },
                    [
                      _c("cargo-input", {
                        staticStyle: { width: "115px", "margin-right": "5px" },
                        attrs: {
                          disabled: true,
                          no: "consigneeCode",
                          placeholder: _vm.$t("SeaExport.ConsigneeId"),
                          "auto-uppercase": true
                        },
                        model: {
                          value: _vm.form.consigneeCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "consigneeCode", $$v)
                          },
                          expression: "form.consigneeCode"
                        }
                      }),
                      _c("cargo-company-select", {
                        staticStyle: {
                          display: "inline-block",
                          width: "145px"
                        },
                        attrs: {
                          disabled: true,
                          no: "consigneeId",
                          "method-params": { consignee: true, active: true },
                          "default-value": _vm.form.consigneeId || ""
                        }
                      })
                    ],
                    1
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, attrs: { "label-width": "0" } },
                      [
                        _c(
                          "special-character-tip",
                          {
                            attrs: {
                              texts: _vm.specialCharCheck["consigneeLine" + i]
                            }
                          },
                          [
                            _c("cargo-input", {
                              ref: "consigneeLine" + i,
                              refInFor: true,
                              attrs: {
                                no: "consigneeLine" + i,
                                disabled: true,
                                "auto-uppercase": true,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "consigneeLine" + i,
                                    i + 1 > 7
                                      ? null
                                      : "consigneeLine" + (i + 1),
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.Consignee"),
                                    _vm.mergeConsigneeLine(),
                                    _vm.splitConsigneeLine,
                                    true,
                                    {
                                      autoHalfWord: true,
                                      autoUppercase: true,
                                      maxChar: _vm.maxChars,
                                      warningCount: _vm.warningCount
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.form["consigneeLine" + i],
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "consigneeLine" + i, $$v)
                                },
                                expression: "form['consigneeLine'+i]"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "margin-right": "20px" },
                  attrs: { "label-width": "50px", "label-position": "left" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.NotifyParty") } },
                    [
                      _c("cargo-input", {
                        staticStyle: { width: "115px", "margin-right": "5px" },
                        attrs: {
                          no: "notifyCode",
                          disabled: true,
                          placeholder: _vm.$t("SeaExport.NotifyId"),
                          "auto-uppercase": true
                        },
                        model: {
                          value: _vm.form.notifyCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "notifyCode", $$v)
                          },
                          expression: "form.notifyCode"
                        }
                      }),
                      _c("cargo-company-select", {
                        staticStyle: {
                          display: "inline-block",
                          width: "145px"
                        },
                        attrs: {
                          no: "notifyId",
                          disabled: true,
                          "method-params": { notify: true, active: true },
                          "default-value": _vm.form.notifyId || ""
                        }
                      })
                    ],
                    1
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, attrs: { "label-width": "0" } },
                      [
                        _c(
                          "special-character-tip",
                          {
                            attrs: {
                              texts: _vm.specialCharCheck["notifyLine" + i]
                            }
                          },
                          [
                            _c("cargo-input", {
                              ref: "notifyLine" + i,
                              refInFor: true,
                              attrs: {
                                no: "notifyLine" + i,
                                disabled: true,
                                "auto-uppercase": true,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "notifyLine" + i,
                                    i + 1 > 7 ? null : "notifyLine" + (i + 1),
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.NotifyParty"),
                                    _vm.mergeNotifyLine(),
                                    _vm.splitNotifyLine,
                                    true,
                                    {
                                      autoHalfWord: true,
                                      autoUppercase: true,
                                      maxChar: _vm.maxChars,
                                      warningCount: _vm.warningCount
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.form["notifyLine" + i],
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyLine" + i, $$v)
                                },
                                expression: "form['notifyLine'+i]"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticStyle: { display: "flex", "flex-direction": "column" } },
          [
            _c("cargo-ag-grid", {
              staticStyle: { width: "100%", height: "350px" },
              attrs: {
                no: "51",
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.ediContainerFinalRowData
              },
              on: {
                gridReady: function(params) {
                  _vm.gridApi = params.api
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            "append-to-body": "",
            no: "advanceTextDialog",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            },
            close: _vm.closeAdvanceText
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              no: "advanceTextDialogTextarea",
              disabled: true,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              "auto-uppercase": _vm.advanceTextDialog.formatObj.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "advanceTextDialogConfirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "advanceTextDialogClose" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                      _vm.closeAdvanceText()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }